<div class="container">
  <app-datagrid *ngIf="options" #datagrid [options]="options">
    <sesio-loader datagrid-spinner></sesio-loader>
    <ng-template appDatagridCell="filesize" let-cell="cell">
      {{ cell.rawValue | filesize }}
    </ng-template>
  </app-datagrid>
</div>
